export default {
    data() {
        return {
            pagination: {
                currentPage: 1,
                totalItems: 0,
                itemsPerPage: 10
            }
        };
    },
    computed: {
        page() {
            return this.pagination.currentPage;
        },
        pagesCount() {
            return Math.ceil(this.pagination.totalItems / this.pagination.itemsPerPage);
        },
        numStart() {
            return (this.pagination.currentPage - 1) * this.pagination.itemsPerPage + 1;
        },
        numEnd() {
            return Math.min(this.pagination.totalItems, this.pagination.currentPage * this.pagination.itemsPerPage);
        },
    },
    methods: {
        goToNext() {
            this.page < this.pagesCount && this.pagination.currentPage++;
        },
        goToPrevious() {
            this.page > 1 && this.pagination.currentPage--;
        },
    }
};
